import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoItem, InfoItemText, LocationInfoContainer } from './styled';
import Icon from '../../../Icon';
import LocationIcon from '../../../../public/static/images/item/location.svg';

interface GalleryLocationInfoProps {
  city?: string | null;
  address?: string | null;
  itemsCount?: number;
}

export const GalleryLocationInfo: React.FC<GalleryLocationInfoProps> = ({
  city,
  address,
  itemsCount
}) => {
  const { t } = useTranslation();

  const scrollHandler = (selector: string) => {
    const element = document.getElementById(selector);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <LocationInfoContainer>
      <InfoItem
        $isLocation
        onClick={() => scrollHandler('location-section')}
        data-cy="gallery-location-info"
      >
        <Icon
          indent={false}
          width={13}
          height={17}
          IconComponent={LocationIcon}
        />
        <InfoItemText tag="body_1">{`${city}${t('pages.residence.city')}, ${address}`}</InfoItemText>
      </InfoItem>
      <InfoItem>
        <InfoItemText tag="body_1" data-cy="gallery-items-info">
          {t('residences.items_count', { count: itemsCount })}
        </InfoItemText>
      </InfoItem>
    </LocationInfoContainer>
  );
};
